import { useContext } from 'react';
import { ThemeContext } from "../theme/ThemeProvider";

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

export default useTheme;